export default "/assets/images/mila-feed-16-thumbnail.jpg?4a47fe355aace0618716253825b83e0a";